/* tslint:disable:component-selector */
import { Component, EventEmitter, Output } from '@angular/core';
import { SharedService } from '../../shared.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {

  @Output() public sidenavToggle = new EventEmitter();

  constructor(
    public dialog: MatDialog,
    public sharedService: SharedService,
  ) {
  }

  onToggleSidenav(): void {
    this.sidenavToggle.emit();
  }
}
